//react
import { useReducer, useEffect, useMemo } from 'react';

//Material_UI
import { Grid, Button, InputBase, Box, Divider, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs'; // Adicione o dayjs para manipulação de datas

//Date-Fns
import { format, isValid } from 'date-fns';

//Lodash
import { capitalize, get } from 'lodash';

//Axios
import axios from 'axios';

//papa-parse
import Papa from 'papaparse';

//CSS
import './transaction.css'

//Local-Imports
import Transactions from './Transactions/Transactions';
import { PAGINATION } from 'utils/constants/pagination';
import { useDispatch, useSelector } from 'store';
import { fetchTransactionData } from 'store/reducers/transactionData';
import Loader from 'components/Loader';
import MainCard from 'components/MainCard';
import ScrollX from 'components/ScrollX';
import { dateFormat, getBEDateFormat } from 'utils/date';
import T from 'utils/constants/T';
import toast from "utils/ToastNotistack";
import CashDAutocomplete from 'components/common/CashDAutocomplete';
import { fetchDeductionTransactionBusinessUnitList, fetchDeductionTransactionPayPeriodList, fetchDeductionTransactionSchedulesList } from 'store/reducers/deductionTransactionFilter';
import { cashdCurrentUser } from 'utils/constants/validations';
import { decimalLimiter, exportData } from 'utils/CommonMethods';
import AnalyticEcommerce from 'components/cards/statistics/AnalyticEcommerce';
import { INCOMPLETE_WITHDRAWAL_STATUSES } from 'utils/constants/transactions';
import { WEBHOOK_ENABLED_SYSTEMS } from 'utils/constants/common';
import { fetchCompanyDetails } from 'store/reducers/companyTabDetails';

const { INITIAL_PAGE, ROWS_PER_PAGE } = PAGINATION;
const EXPORT_PAGE_SIZE = 10000;
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  border: "1px solid #d9d9d9",
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 1.5),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(3)})`,
    transition: theme.transitions.create('width'),
    width: '100%'
  },
}));
const TransactionPage = () => {
  const dispatch = useDispatch();
  const { selectedCompany } = useSelector((state: any) => state.dashboardSearch);
  const selectedCompanyName = get(selectedCompany, "company_name", "");
  const selectedCompanyId = get(selectedCompany, "_id", "");
  const { transactionTableList, countStastics, totalTransactionItems, totalTransactionPages, loader, pageNo, pageSize } = useSelector((state: any) => state.transactionData);
  const { payPeriodList, scheduleList, businessUnitList } = useSelector((state: any) => state.deductionTransactionFilter);
  const { currencySymbol, systemPayrollCode, webhookEnabled } = useSelector((state: any) => state.companyTabData);
  let cs = currencySymbol ? currencySymbol : T.DOLLAR;
  const today = dayjs().format('YYYY-MM-DD');
  const thirtyDaysAgo = dayjs().subtract(30, 'day').format('YYYY-MM-DD');

  const [localState, setLocalState] = useReducer(
    (prevState: any, newState: any) => ({ ...prevState, ...newState }),
    {
      page: pageNo,
      rowsPerPage: pageSize,
      fromDate: thirtyDaysAgo,
      toDate: today,
      schedule: null,
      payPeriod: null,
      employee: "",
      payrollId: "",
      businessUnit: null,
      isLoading: false,
    }
  );

  const {
    page,
    rowsPerPage,
    fromDate,
    toDate,
    schedule,
    payPeriod,
    employee,
    payrollId,
    businessUnit,
    isLoading,
  } = localState;

  const isTableLoading = !!loader || !!isLoading;

  //filters arrays
  const payPeriodId = payPeriod ? get(payPeriod, "_id", "") : null;
  const scheduleId = useMemo(() => {
    if (!schedule) return null;
    const isWebhookEnabled = webhookEnabled && WEBHOOK_ENABLED_SYSTEMS.includes(systemPayrollCode);
    const isSupportedPayrollSystem = ["TIMESITE_PRO"].includes(systemPayrollCode);
    const key = (isSupportedPayrollSystem || isWebhookEnabled) ? "cycle_id" : "_id";
    console.log("Key", key, schedule, webhookEnabled)
    return get(schedule, key, "");
  }, [schedule, systemPayrollCode, webhookEnabled]);
  const businessUnitId = businessUnit ? get(businessUnit, "_id", "") : null;

  useEffect(() => {
    dispatch(fetchCompanyDetails(selectedCompanyId));
  }, [selectedCompanyId]);

  //filter listing arrays initial rendering
  useEffect(() => {
    if (selectedCompanyId) {
      dispatch(fetchDeductionTransactionPayPeriodList(selectedCompanyId))
      dispatch(fetchDeductionTransactionSchedulesList(selectedCompanyId))
      if (selectedCompanyName.includes(capitalize(T.HUDSON))) {
        dispatch(fetchDeductionTransactionBusinessUnitList(selectedCompanyId))
      }
    }
  }, [dispatch, selectedCompanyId, selectedCompanyName])

  //Get schedule name from API
  const getScheduleName: any = (data: any, systemCode: string) => {
    let scheduleName = { payPeriodName: "", payPeriodId: "" };
    const isWebhookEnabled = get(data, "company.webhook_enabled", false);
    const isWebhookSystem = WEBHOOK_ENABLED_SYSTEMS.includes(systemCode);
    console.log("systemCode", systemCode)

    if (systemCode === T.DEPUTY.toUpperCase()) {
      scheduleName.payPeriodName = get(data, "pay_deductions.pay_period_originations[0].name", "");
      scheduleName.payPeriodId = get(data, "pay_deductions.pay_period_originations[0]._id", "");
    } else if (systemCode === T.KEYPAY.toUpperCase()) {
      scheduleName.payPeriodName = get(data, "pay_deductions.keypay_pay_schedules[0].name", "");
      scheduleName.payPeriodId = get(data, "pay_deductions.keypay_pay_schedules[0]._id", "");
    } else if (systemCode === T.MYOBEXO.toUpperCase()) {
      const payPeriodName = data.pay_deductions?.pay_period_originations[0]?.display_name || data.pay_deductions?.pay_period_originations?.display_name || "";
      const payPeriodId = data.pay_deductions?.pay_period_originations[0]?._id || data.pay_deductions?.pay_period_originations?._id || ""

      scheduleName.payPeriodName = payPeriodName;
      scheduleName.payPeriodId = payPeriodId;
    } else if ((isWebhookEnabled && isWebhookSystem) || ["TIMESITE_PRO", T.MYOBEXO.toUpperCase()].includes(systemCode)) {
      const payPeriodName = data.pay_deductions?.pay_period_originations[0]?.name || data.pay_deductions?.pay_period_originations?.name || "";
      const payPeriodId = data.pay_deductions?.pay_period_originations[0]?._id || data.pay_deductions?.pay_period_originations?._id || ""

      scheduleName.payPeriodName = payPeriodName;
      scheduleName.payPeriodId = payPeriodId;
    } else {
      scheduleName.payPeriodName = get(data, "pay_deductions.xero_pay_calendars[0].Name", "");
      scheduleName.payPeriodId = get(data, "pay_deductions.xero_pay_calendars[0]._id", "");
    }
    return scheduleName;
  }

  const transactionFinalData: any = [];
  transactionTableList.map((data: any, index: number) => {
    const systemCode = get(data, "company.systems[0].code", "");


    const scheduleData = getScheduleName(data, systemCode);
    const payPeriods = `${dateFormat(get(data, "pay_deductions.pay_periods[0].start_date", null))} ${T.TO} ${dateFormat(get(data, "pay_deductions.pay_periods[0].end_date", null))}`
    const systemPayrollId = data.staff.system_employee_id;
    transactionFinalData[index] = {
      srNo: index + 1,
      company_name: data?.company?.company_name,
      employee_name: data.staff.fullname,
      pay_periods: payPeriods,
      schedule_details: scheduleData,
      Date: data.pay_deductions.date,
      transaction_id: data.pay_deductions.transaction_id,
      system_payroll_id: systemPayrollId,
      debit: decimalLimiter(data.total_deduction),
      amount: decimalLimiter(data.amount),
      fee: decimalLimiter(data.fee_amount),
      status: data.pay_deductions.status
    }
  }
  );



  // Page change handler
  const handlePageChange = (newPage: number) => {
    setLocalState({ page: newPage });
    document.getElementsByClassName("MuiTableContainer-root")[0].scrollTop = 0;
  };

  // Rows per page change handler
  const handleRowsPerPageChange = (event: any) => {
    const { value } = event.target;
    setLocalState({ page: INITIAL_PAGE, rowsPerPage: value });
  };

  //Date filter handler
  const onHandleDateChange = (newValue: any, type: string) => {
    const validDate = newValue ? new Date(newValue) : null;
    setLocalState({
      [type]: validDate && isValid(validDate) ? getBEDateFormat(validDate) : null
    });
  };

  //Handler for clearing the filter
  const handleClearFilters: any = () => {
    setLocalState({ fromDate: null, toDate: null, payPeriod: null, schedule: null, businessUnit: null, payrollId: "", employee: "", page: INITIAL_PAGE, rowsPerPage: ROWS_PER_PAGE });
  }


  //Autocomplete value change handler
  const onHandleAutoCompleteChange = (type: string, newValue: any) => {
    setLocalState({ [type]: newValue });
  };


  //On Change Handler for search filters
  const onHandleChange = (e: any) => {
    const { name, value } = e.target;
    setLocalState({ [name]: value })
  }


  //Render formatted export file data

  const formattedExportData = (finalData: any[]) => {
    const transactionExportFinalData: any = [];
    finalData.forEach((data: any, index: number) => {
      const systemCode = get(data, "company.systems[0].code", "");
      const scheduleData = getScheduleName(data, systemCode);

      const payPeriods = `${dateFormat(get(data, "pay_deductions.pay_periods[0].start_date", null))} ${T.TO.toLowerCase()} ${dateFormat(get(data, "pay_deductions.pay_periods[0].end_date", null))}`;
      const systemPayrollId = data.staff.system_employee_id;
      const capitalAmount = data.total_deduction - data.fee_amount;
      const deductionDate = new Date(data.pay_deductions.date);
      const date = format(deductionDate, "dd-MM-yyyy h:mm:ss a");
      const status = get(data, "pay_deductions.status");
      const amount = get(data, "amount", 0);
      transactionExportFinalData[index] = {
        srNo: index + 1,
        company_name: data.company.company_name,
        employee_name: data.staff.fullname,
        pay_periods: payPeriods,
        schedule_details: scheduleData?.payPeriodName || 'N/A',
        date: date,
        transaction_id: data.pay_deductions.transaction_id,
        system_payroll_id: systemPayrollId,
        capital: `${cs}${capitalAmount.toFixed(2)}`,
        fee: `${cs}${data.fee_amount.toFixed(2)}`,
        total: `${cs}${data.total_deduction.toFixed(2)}`,
        status: INCOMPLETE_WITHDRAWAL_STATUSES.includes(status) ? `${status} ${cs}${Number(amount).toFixed(2)}` : status,
      };
    }
    );
    return transactionExportFinalData;
  }

  const handleCSVExport = async () => {
    try {
      setLocalState({ isLoading: true });
      const { token } = cashdCurrentUser();
      const {
        REACT_APP_BACKEND_API_PRIVATE_BASE_URL: baseURL,
        REACT_APP_X_API_KEY: X_API_KEY,
      } = process.env;

      // Common configuration
      const headers = {
        "x-api-key": X_API_KEY,
        token: `${token}`,
        "Content-Type": "application/json",
      };

      const params = {
        pageSize: EXPORT_PAGE_SIZE,
        company_id: selectedCompanyId,
        pay_period_id: payPeriodId || "",
        schedule_id: scheduleId || "",
        business_unit_id: businessUnitId || "",
        startDate: fromDate || "",
        endDate: toDate || "",
        mode: 0,
        isAll: 0,
        payroll_id: payrollId,
        employee_name: typeof employee === "string" ? employee.trim() : employee,
      };

      // Initial request to get total pages
      const initialResponse = await axios.get(
        `${baseURL}/v2/api/timesheets/getAllDeductions`,
        {
          headers,
          params: { ...params, page: INITIAL_PAGE },
        }
      );

      const {
        data,
        totalItem,
        totalPage: totalPagesCount,
      } = initialResponse.data;
      const safeResult = Array.isArray(data) ? data : [];
      let finalData = safeResult;

      // Handle data based on total items
      if (totalItem <= EXPORT_PAGE_SIZE) {
        exportCSV(finalData);
      } else {
        // Fetch remaining pages concurrently
        const pageRequests = Array.from(
          { length: Math.max(totalPagesCount - 1, 0) },
          (_, i) =>
          axios.get(`${baseURL}/v2/api/timesheets/getAllDeductions`, {
            headers,
            params: { ...params, page: i + 2 },
          })
        );

        const responses = await Promise.all(pageRequests);
        finalData = responses.reduce(
          (acc: any[], res) => {
            const pageResult = Array.isArray(res?.data?.data) ? res.data.data : [];
            return [...acc, ...pageResult];
          },
          finalData
        );
        exportCSV(finalData);
      }
    } catch (error) {
      toast(get(error, "message", ""), { variant: "error" });
    } finally {
      setLocalState({ isLoading: false });
    }
  };

  // Helper function to export CSV
  const exportCSV = (data: any) => {
    const formattedData = formattedExportData(data);
    const csvData = Papa.unparse(formattedData);
    exportData(csvData, "data.csv", "text/csv;charset=utf-8;");
  };

  useEffect(() => {
    const hasPartialDate = (fromDate && !toDate) || (!fromDate && toDate);
    if (hasPartialDate) return;

    const companyToFetch = selectedCompanyId || "";

    const from = fromDate || "";
    const to = toDate || "";

    dispatch(
      fetchTransactionData({
        page,
        pageSize: rowsPerPage,
        fromDate: from,
        toDate: to,
        selectedCompanyId: companyToFetch,
        pay_period_id: payPeriodId,
        schedule_Id: scheduleId,
        business_Unit_Id: businessUnitId,
        payrollId,
        employee,
      })
    );
  }, [
    selectedCompanyId,
    payrollId,
    employee,
    payPeriod,
    schedule,
    businessUnit,
    dispatch,
    payPeriodId,
    scheduleId,
    businessUnitId,
    fromDate,
    toDate,
    page,
    rowsPerPage,
  ]);



  return (
    <>
      {isTableLoading && <Loader />}
      <MainCard
        title={
          <>
            <Grid container spacing={1} className="tableSearchBox">
              <Grid item xs={12} sm={6} md={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="From Date"
                    inputFormat="DD/MM/YYYY"
                    value={fromDate}
                    onChange={(date) =>
                      onHandleDateChange(date, "fromDate")
                    }
                    renderInput={(params) => <TextField fullWidth {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="To Date"
                    inputFormat="DD/MM/YYYY"
                    value={toDate}
                    onChange={(date) => onHandleDateChange(date, "toDate")}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              {selectedCompanyId && (
                <Grid item xs={12} sm={6} md={systemPayrollCode === "RECKON" ? 4 : 3}>
                  <CashDAutocomplete
                    placeholder={T.PAY_PERIOD}
                    displayRemoveButton="none"
                    listDetails={payPeriodList}
                    value={payPeriod}
                    getByLabelText={(option: any) => {
                      const dateRange = `${dateFormat(option.start_date)} To ${dateFormat(option.end_date)}`;
                      if (systemPayrollCode === "RECKON") {
                        const reckonLabel = get(option, "xero_pay_calendar.Name", "");
                        return reckonLabel ? `${dateRange} - ${reckonLabel}` : dateRange;
                      }
                      if (systemPayrollCode === "MYOBEXO") {
                        const payBasis = get(option, "pay_period_origination.pay_basis", "");
                        const label =
                          payBasis === "Hourly" ? "Timesheet" : payBasis ? "Salary" : "";
                        return label ? `${dateRange} - ${label}`: dateRange;
                      }
                      return dateRange;
                    }}
                    onHandleChange={(event: any, newValue: any) =>
                      onHandleAutoCompleteChange("payPeriod", newValue)
                    }
                  />
                </Grid>
              )}
              {selectedCompanyId && (
                <Grid item xs={12} sm={6} md={3}>
                  <CashDAutocomplete
                    placeholder={T.SCHEDULE}
                    displayRemoveButton="none"
                    listDetails={scheduleList}
                    value={schedule}
                    getByLabelText={(option: any) =>
                      (systemPayrollCode === "MYOBEXO" && get(option, "display_name")) || get(option, "name", "") || get(option, "Name", "")
                    }
                    onHandleChange={(event: any, newValue: any) =>
                      onHandleAutoCompleteChange("schedule", newValue)
                    }
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={2}>
                <Search>
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  <StyledInputBase
                    placeholder={T.EMPLOYEE}
                    name="employee"
                    value={employee}
                    inputProps={{ "aria-label": "search" }}
                    onChange={onHandleChange}
                  />
                </Search>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <Search>
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  <StyledInputBase
                    placeholder={T.PAYROLL_ID}
                    name="payrollId"
                    value={payrollId}
                    inputProps={{ "aria-label": "search" }}
                    onChange={onHandleChange}
                  />
                </Search>
              </Grid>
              {selectedCompanyId &&
                selectedCompanyName.includes(capitalize(T.HUDSON)) && (
                  <Grid item xs={12} sm={6} md={2}>
                    <CashDAutocomplete
                      placeholder={T.BUSINESS_UNIT}
                      displayRemoveButton="none"
                      listDetails={businessUnitList}
                      value={businessUnit}
                      getByLabelText={(option: any) =>
                        get(option, "name", "")
                      }
                      onHandleChange={(event: any, newValue: any) =>
                        onHandleAutoCompleteChange("businessUnit", newValue)
                      }
                    />
                  </Grid>
                )}
              <Grid item xs={3} sm={3} md={1}>
                <Box
                  sx={{
                    display: 'flex',
                    "& h6": {
                      m: 1,
                    },
                    "& hr": {
                      mx: 0.2,
                      my: 0.1,
                    },
                  }}
                >
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                  />
                  <Typography
                    variant="h6"
                    className="reset"
                    onClick={handleClearFilters}
                  >
                    {T.RESET}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </>
        }
        content={false}
        secondary={
          <>
            {
              <Box sx={{ display: "block", pl: 4 }}>
                <Button startIcon={<FileDownloadOutlinedIcon />} variant='contained' onClick={handleCSVExport}>
                  {T.EXPORT}
                </Button>
              </Box>
            }
          </>
        }
      >
        <Grid container paddingX={1} paddingTop={1} rowSpacing={2.75} columnSpacing={2.75}>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <AnalyticEcommerce
              title="Transactions"
              count={countStastics?.totalTransactions}
              isLoss={true}
              color={'primary'}
              extra="35,000"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2} lg={3}>
            <AnalyticEcommerce
              title="Volume"
              count={`${cs}` + countStastics?.totalTransactionValue}
              isLoss={true}
              color={'primary'}
              extra="35,000"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2} lg={3}>
            <AnalyticEcommerce
              title="Fee total"
              count={`${cs}` + countStastics?.totalFeeValue}
              isLoss={true}
              color={'primary'}
              extra="35,000"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2} lg={3}>
            <AnalyticEcommerce
              title="Success rate"
              count={countStastics?.successPercentage + '%'}
              isLoss={true}
              color={'primary'}
              extra="35,000"
            />
          </Grid>
        </Grid>
        <ScrollX>
          <Transactions
            allTableRows={transactionFinalData}
            cs={cs}
            totalTableRowsCount={totalTransactionItems}
            totalPageCount={totalTransactionPages}
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        </ScrollX>
      </MainCard>
    </>
  );
};

export default TransactionPage;